import QualificationQuestion from './QualificationQuestion.component';

export default QualificationQuestion;
